import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allJugadoresAction,
  setActivoJugadoresAction,
} from './JugadoresAction';
import FormJugadores from './components/FormJugadores';
import ListadoJugadores from './components/ListadoJugadores';

const JugadoresView = ({
  isCreate = true,
  isEdit = true,
  showColumnEquipo = true,
}) => {
  const dispatch = Redux.useDispatch();

  const jugadoresStore = Redux.useSelector((state) => state.jugadores);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        {isCreate && (
          <BotonComponent
            click={async () => {
              await setActivoJugadoresAction(dispatch, null);
              setOpenModalForm(true);
            }}
            green
            addIcon
            text="ASIGNAR"
            mr={2}
            ml={2}
            mt={2}
            mb={1}
          />
        )}
        <BotonComponent
          mt={2}
          mb={1}
          click={async () => {
            await setActivoJugadoresAction(dispatch, null);
            await allJugadoresAction(dispatch, jugadoresStore.params);
          }}
          disabled={
            jugadoresStore.all.length === 0 || jugadoresStore.loadingAll
          }
          white
          refreshIcon
          text={jugadoresStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={12}>
        <ListadoJugadores
          setOpenModalForm={(val) => setOpenModalForm(val)}
          isEdit={isEdit}
          showColumnEquipo={showColumnEquipo}
        />
      </Grid>
      <ModalComponent
        id="modalFormJugadores"
        title={`${
          jugadoresStore.activo
            ? `Editar ${jugadoresStore.activo.nombre}`
            : 'Asignar jugador'
        }`}
        maxWidth="md"
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormJugadores
          activo={jugadoresStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default JugadoresView;
